/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sip_compound_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How does compounding frequency affect returns?`)
};

const es_sip_compound_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo afecta la frecuencia de composición los retornos?`)
};

const de_sip_compound_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie beeinflusst die Zerlegungshäufigkeit die Renditen?`)
};

const nl_sip_compound_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe beïnvloedt samenstellingsfrequentie rendement?`)
};

const fr_sip_compound_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment la fréquence de composition affecte-t-elle les rendements ?`)
};

const it_sip_compound_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come influisce la frequenza di capitalizzazione sui rendimenti?`)
};

const pt_br2_sip_compound_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como a frequência de composição afeta os retornos?`)
};

const pt_sip_compound_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como é que a frequência de capitalização afeta os retornos?`)
};

const ja_sip_compound_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`複利頻度はリターンにどのような影響を与えますか？`)
};

const zh_sip_compound_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`复利频率如何影响收益？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sip_compound_faq2_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sip_compound_faq2_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sip_compound_faq2_q", locale)
	if (locale === "en") return en_sip_compound_faq2_q(inputs)
	if (locale === "es") return es_sip_compound_faq2_q(inputs)
	if (locale === "de") return de_sip_compound_faq2_q(inputs)
	if (locale === "nl") return nl_sip_compound_faq2_q(inputs)
	if (locale === "fr") return fr_sip_compound_faq2_q(inputs)
	if (locale === "it") return it_sip_compound_faq2_q(inputs)
	if (locale === "pt-BR") return pt_br2_sip_compound_faq2_q(inputs)
	if (locale === "pt") return pt_sip_compound_faq2_q(inputs)
	if (locale === "ja") return ja_sip_compound_faq2_q(inputs)
	return zh_sip_compound_faq2_q(inputs)
};